<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-title">
          <h5>Configuration</h5>
          <div class="ibox-tools">
            <span class="label label-info">Read-Only</span>
          </div>
        </div>
        <div class="ibox-content">
          @if (!config) {
          <div class="alert alert-warning">
            <i class="fa fa-exclamation-triangle"></i>
            Configuration not loaded yet. Please refresh the page.
          </div>
          } @else {
          <div class="alert alert-info">
            <i class="fa fa-info-circle"></i>
            This page displays the current application configuration settings. These values are read-only and loaded
            from the configuration files.
          </div>

          <!-- Basic Configuration -->
          <div class="row mb-4">
            <div class="col-md-6">
              <div class="form-group">
                <label>Application Title</label>
                <div class="form-control-static">{{ config.title }}</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>API Base Path</label>
                <div class="form-control-static">{{ config.apiBasePath }}</div>
              </div>
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-md-6">
              <div class="form-group">
                <label>SignalR Hub URL</label>
                <div class="form-control-static">{{ config.signalRHubUrl }}</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Show Verified Button</label>
                <div class="form-control-static">
                  <span class="badge" [class.badge-success]="config.showVerifiedButton"
                    [class.badge-default]="!config.showVerifiedButton">
                    {{ formatValue(config.showVerifiedButton) }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Configuration Sections -->
          @for (sectionKey of getObjectKeys(config); track sectionKey) {
          @if (isObject(getConfigValue(config, sectionKey)) && sectionKey !== 'navItems') {
          <div class="config-section mb-4">
            <h4 class="section-title" [class]="getSectionClass(sectionKey)">
              <i class="fa fa-cog"></i> {{ getDisplayName(sectionKey) }}
            </h4>

            <div class="panel panel-default">
              <div class="panel-body">
                <div class="row">
                  @for (key of getObjectKeys(getConfigValue(config, sectionKey)); track key) {
                  <div class="col-md-6 mb-3">
                    <div class="form-group">
                      <label>{{ getDisplayName(key) }}</label>
                      @if (isObject(getConfigValue(getConfigValue(config, sectionKey), key))) {
                      <div class="nested-config">
                        @for (nestedKey of getObjectKeys(getConfigValue(getConfigValue(config, sectionKey), key)); track
                        nestedKey) {
                        <div class="nested-item">
                          <strong>{{ getDisplayName(nestedKey) }}:</strong>
                          <span class="nested-value">{{ formatValue(getConfigValue(getConfigValue(getConfigValue(config,
                            sectionKey), key), nestedKey)) }}</span>
                        </div>
                        }
                      </div>
                      } @else if (isArray(getConfigValue(getConfigValue(config, sectionKey), key))) {
                      <div class="form-control-static array-value">
                        @if (getConfigValue(getConfigValue(config, sectionKey), key).length === 0) {
                        <em class="text-muted">Empty array</em>
                        } @else {
                        <ul class="list-unstyled">
                          @for (item of getConfigValue(getConfigValue(config, sectionKey), key); track $index) {
                          <li><code>{{ formatValue(item) }}</code></li>
                          }
                        </ul>
                        }
                      </div>
                      } @else {
                      <div class="form-control-static">
                        <code>{{ formatValue(getConfigValue(getConfigValue(config, sectionKey), key)) }}</code>
                      </div>
                      }
                    </div>
                  </div>
                  }
                </div>
              </div>
            </div>
          </div>
          }
          }


          }
        </div>
      </div>
    </div>
  </div>
</div>